import React from "react"
import { Link, useNavigate } from "react-router-dom"
import { FaHome, FaArrowLeft } from "react-icons/fa"

const NotFound = () => {
  const navigate = useNavigate()

  const handleGoBack = () => {
    if (window.history.length > 1) {
      window.history.back()
    } else {
      navigate("/dashboard")
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-2xl mx-auto text-center relative z-10">

        {/* 404 Number with Modern Styling */}
        <div className="relative mb-8">
          <h1 className="text-8xl md:text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#0f4d97] to-[#ed2a62] leading-none">
            404
          </h1>
          <div className="absolute inset-0 text-8xl md:text-9xl font-black text-gray-200 transform translate-x-2 translate-y-2" style={{ zIndex: -1 }}>
            404
          </div>
        </div>

        {/* Error Message */}
        <div className="mb-8 space-y-3">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">Page Not Found</h2>
          <p className="text-gray-600 text-lg max-w-md mx-auto leading-relaxed">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center relative z-20">
          <Link
            to="/dashboard"
            className="group flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-[#0f4d97] to-[#ed2a62] text-white rounded-xl font-medium shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 cursor-pointer"
            style={{ pointerEvents: 'auto' }}
          >
            <FaHome className="w-4 h-4" />
            <span>Go to Dashboard</span>
          </Link>

          <button
            type="button"
            onClick={handleGoBack}
            className="group flex items-center gap-3 px-6 py-3 bg-white text-gray-700 border border-gray-300 rounded-xl font-medium hover:bg-gray-50 hover:border-gray-400 transform hover:scale-105 transition-all duration-200 cursor-pointer"
            style={{ pointerEvents: 'auto' }}
          >
            <FaArrowLeft className="w-4 h-4" />
            <span>Go Back</span>
          </button>
        </div>

        {/* Decorative Elements */}
        <div className="mt-12 relative" style={{ zIndex: 1 }}>
          <div className="absolute inset-0 flex items-center justify-center opacity-5" style={{ pointerEvents: 'none' }}>
            <div className="w-96 h-96 bg-gradient-to-r from-[#0f4d97] to-[#ed2a62] rounded-full blur-3xl"></div>
          </div>
        </div>

        {/* Help Text */}
        <div className="mt-8 pt-8 border-t border-gray-200 relative z-20">
          <p className="text-sm text-gray-500">
            Need help? Contact our{" "}
            <Link
              to="/support-request"
              className="text-[#0f4d97] hover:text-[#ed2a62] font-medium transition-colors duration-200 cursor-pointer"
              style={{ pointerEvents: 'auto' }}
            >
              support team
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default NotFound
